import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { FdFieldConfigs } from 'src/app/shared/fd-form-components/fd-form-components.module';
import { FdSelectConfig } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';
import { Subject } from 'rxjs';
import { ServicesTypePostModel } from 'src/app/shared/models/service-type-post.model';
import { ServicesConfigService } from '../../services/services-config.service';
import { ServicesTypeModel } from 'src/app/shared/models/services-type.model';
import { Messages } from 'src/app/shared/messages/messages';
import { RequiredIfValidator } from 'src/app/shared/validators/required-if-validator';
import { DialogService } from 'src/app/shared/service/dialog.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LoadingService } from 'src/app/shared/service/loading.service';

@Component({
    selector: 'app-options-service',
    templateUrl: './options-service.component.html',
    styleUrls: ['./options-service.component.scss'],
    standalone: false
})
export class OptionsServiceComponent implements OnInit {

  loading = false;
  terminalTypeSelected: string;
  isVenda = false;
  tooglemessage: string;
  imageFile: File = null;
  isCnp: boolean = false;
  imageLoadedUrl: string | SafeResourceUrl = null;
  isConfigTechnologyAble: boolean = false;
  advantagesObject = {
    advantages: []
  };
  detailsObject = {
    details: []
  };

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;
  isFieldsLoaded: Subject<boolean> = new Subject();
  typeList = [
    {
      label: 'Aluguel',
      value: 'RENT'
    }, {
      label: 'Venda',
      value: 'SALES'
    },
    {
      label: 'Novo Comodato',
      value: 'NEW_LEND'
    }];

  constructor(
    public dialogRef: MatDialogRef<OptionsServiceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      servicesTypeModel: ServicesTypeModel
    },
    private servicesConfigService: ServicesConfigService,
    private formBuilder: UntypedFormBuilder,
    private dialogService: DialogService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private loadingService: LoadingService
  ) { }


  async ngOnInit() {
    this.loadingService.show();
    this.formGroup = this.createFormGroup();
    this.fields = this.createFields();

    (this.fields.type as FdSelectConfig).items = [];
    (this.fields.type as FdSelectConfig).items.push(...this.typeList);

    this.isConfigTechnologyAble = this.data.servicesTypeModel.isConfigTechnologyAble;
    this.isCnp = this.data.servicesTypeModel.technologyGroup === "COM";
    this.getfieldsSelected(this.data.servicesTypeModel);
    if (this.isConfigTechnologyAble){
      await this.getServiceImage(this.data.servicesTypeModel);
      await this.getServiceDetails(this.data.servicesTypeModel);
    }

    this.loadingService.hide();
  }

  createFormGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      institutionNumber: ['', Validators.required],
      seriviceContract: ['', Validators.required],
      serviceID: ['', Validators.required],
      typeTerminal: ['', Validators.required],
      name: ['', Validators.required],
      disclaimer: [''],
      type: ['', Validators.required],
      producer: ['', RequiredIfValidator(() => this.isVenda)],
      deviceOnAgency: ['', Validators.required],
      imageDescription: ['', RequiredIfValidator(() => this.imageFile != null || this.imageLoadedUrl != null)],
      status: [''],
      piloto: ['']
    });
  }

  nameComercialTechMask(value): RegExp[] {
    let digitRegExp = /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑýÝ.0-9-) _(+/]/;
    const arr: RegExp[] = value
      .split('')
      .map((char) => {
        if (digitRegExp.test(char)) {
          return digitRegExp;
        }
      });
    return arr.filter(regexp => !!regexp);
  }

  createFields(): FdFieldConfigs {
    return {
      institutionNumber: {
        label: 'Número da Instituição',
        disabled: true,
        items: [],
        controlName: 'institutionNumber',
        panelWidth: '320px',
        messages: {
          required: 'Informe o número da instituição',
          invalid: 'Número da instituição inválido'
        }
      },
      seriviceContract: {
        label: 'Service Contract',
        disabled: true,
        items: [],
        controlName: 'seriviceContract',
        panelWidth: '320px',
        messages: {
          required: 'informe o serivice contract',
          invalid: 'Serivice contract inválido'
        }
      },
      serviceID: {
        label: 'service ID',
        disabled: true,
        items: [],
        controlName: 'serviceID',
        panelWidth: '320px',
        messages: {
          required: 'informe o service ID',
          invalid: 'Serivice service ID'
        }
      },
      typeTerminal: {
        label: 'Tipo de Terminal',
        disabled: true,
        items: [],
        controlName: 'typeTerminal',
        panelWidth: '320px',
        messages: {
          required: 'informe o Tipo de Terminal',
          invalid: 'Tipo de Terminal inválido'
        }
      },
      name: {
        label: 'Nome Comercial da Tecnologia',
        disabled: false,
        items: [],
        controlName: 'name',
        mask: this.nameComercialTechMask,
        maxLength: 255,
        messages: {
          required: 'informe o Nome Comercial da Tecnologia',
          invalid: 'Nome Comercial da Tecnologia inválido'
        }
      },
      disclaimer: {
        label: 'Disclaimer',
        disabled: false,
        items: [],
        controlName: 'disclaimer',
        maxLength: 255
      },
      type: {
        label: 'Tipo de tecnologia',
        disabled: false,
        items: [],
        controlName: 'type',
        panelWidth: '320px',
        messages: {
          required: 'Selecione o tipo de tecnologia',
          invalid: 'Valor selecionado inválido'
        }
      },
      producer: {
        label: 'Fabricante',
        disabled: false,
        items: [],
        controlName: 'producer',
        panelWidth: '320px',
        messages: {
          required: 'Selecione um fabricante',
          invalid: 'Fabricante inválido'
        }
      },
      deviceOnAgency: {
        label: 'Máquina na Agência',
        disabled: false,
        controlName: 'deviceOnAgency',
        panelWidth: '320px',
        messages: {
          required: 'Selecione uma opção válida no campo Máquina na Agência',
          invalid: 'Valor selecionado inválido'
        }
      },
      imageDescription: {
        label: 'Descrição da imagem',
        disabled: false,
        items: [],
        controlName: 'imageDescription',
        maxLength: 255,
        messages: {
          required: 'informe a descrição da imagem',
          invalid: 'Descrição da imagem inválida'
        }
      },
      status: {
        label: 'Status',
        disabled: false,
        controlName: 'status',
        panelWidth: '320px',
        messages: {
          invalid: 'Status inválido'
        }
      },
      piloto: {
        label: 'Piloto',
        disabled: false,
        controlName: 'piloto',
        panelWidth: '320px',
        messages: {
          invalid: 'Status inválido'
        }
      }
    };
  }

  async save(): Promise<void> {
    this.loadingService.show();
    if (!this.formGroup.valid) {
      this.dialogService.openDialog(Messages.DATA_REQUIRED_ERROR);
      return;
    }

    let ServicesType = new ServicesTypePostModel();

    ServicesType.serviceId = Number(this.data.servicesTypeModel.serviceId);
    ServicesType.serviceContractId = this.data.servicesTypeModel.serviceContractId;
    ServicesType.modality = this.formGroup.value.type;
    ServicesType.tradeName = this.formGroup.value.name;
    ServicesType.institutionId = this.data.servicesTypeModel.institutionId;
    ServicesType.terminalManufacturerId = this.formGroup.value.producer;
    ServicesType.deviceOnAgency = this.formGroup.value.deviceOnAgency;
    ServicesType.isEnabled = this.formGroup.value.status;
    ServicesType.disclaimer = this.formGroup.value.disclaimer;
    ServicesType.isPiloto = this.formGroup.value.piloto
    if (
      (['SALES', 'NEW_LEND', 'RENT'].includes(ServicesType.modality) && !ServicesType.tradeName) || !ServicesType.modality
    ) {
      this.dialogService.openDialog(Messages.DATA_REQUIRED_ERROR);
      return;
    }

    if ( this.isConfigTechnologyAble && (!this.advantagesObject.advantages.length || !this.detailsObject.details.length)) {
      this.dialogService.openDialog(Messages.TECHNOLOGY_ADVANTAGES_REQUIRED);
      return;
    }

    this.advantagesObject.advantages = this.advantagesObject.advantages.filter(item => item != null && item.trim());
    this.detailsObject.details = this.detailsObject.details.filter(item => item != null && item.trim());
    ServicesType.advantages = JSON.stringify(this.advantagesObject.advantages);
    ServicesType.details = JSON.stringify(this.detailsObject.details);



    try {
      await this.servicesConfigService.updateServiceConfig(ServicesType).toPromise();
      await this.saveImage(ServicesType);
      this.dialogService.openDialog(Messages.EDIT_SAVE_SUCCESS);
    } catch (error) {
      this.dialogService.openDialog(Messages.EDIT_SAVE_ERROR);
    } finally {
      this.loadingService.hide();
      this.dialogRef.close();
    }
  }

  getfieldsSelected(fields: ServicesTypeModel): void {

    this.formGroup.controls.institutionNumber.setValue(fields.institutionId);

    this.formGroup.controls.seriviceContract.setValue(fields.serviceContractId);

    this.formGroup.controls.serviceID.setValue(fields.serviceId);

    this.formGroup.controls.typeTerminal.setValue(fields.serviceName);

    this.formGroup.controls.name.setValue(fields.tradeName);

    this.formGroup.controls.type.setValue(this.checkModality(fields.modality));

    this.formGroup.controls.deviceOnAgency.setValue(fields.deviceOnAgency || false);

    this.formGroup.controls.status.setValue(fields.isEnabled);

    this.formGroup.controls.imageDescription.setValue(fields.imageDescription);

    this.formGroup.controls.disclaimer.setValue(fields.disclaimer);

    this.formGroup.controls.piloto.setValue(fields.isPiloto);

    this.checkType();
  }

  getTerminalManutacturer() {
    this.servicesConfigService.terminalManutacturer()
      .subscribe(list => {
        if (list != null) {
          (this.fields.producer as FdSelectConfig).items = [];
          (this.fields.producer as FdSelectConfig).items.push(...list);

          if (this.data.servicesTypeModel.terminalManufacturerId) {
            this.formGroup.controls.producer.setValue(this.data.servicesTypeModel.terminalManufacturerId.toString());
          }
        }
      });
  }

  close() {
    this.dialogRef.close();
  }

  checkType() {
    if (this.formGroup.value.type === 'SALES' || this.formGroup.value.type === 'NEW_LEND') {
      this.isVenda = true;
      this.getTerminalManutacturer();
    } else {
      this.isVenda = false;
      this.formGroup.controls.producer.setValue('');
    }
  }

  checkToggle(checked: boolean) {
    if (checked) {
      return 'Ativo';
    } else {
      return 'Inativo';
    }
  }

  toggleChange(event: any) {
    if (event.checked) {
      this.tooglemessage = 'Ativo';
    } else {
      this.tooglemessage = 'Inativo';
    }
  }

  checkModality(modality: string): string {
    switch (modality) {
      case 'Venda': {
        return 'SALES';
        break;
      }
      case 'Aluguel': {
        return 'RENT';
        break;
      }
      case 'Novo Comodato': {
        return 'NEW_LEND';
        break;
      }
      default: {
        return null;
        break;
      }
    }
  }

  onImageSelected(file: File): void {
    this.imageFile = file;
    this.imageLoadedUrl = null;
  }

  onImageDeleted() {
    if(this.formGroup.controls.imageDescription.errors?.['required']) {
      this.formGroup.controls.imageDescription.setErrors(null);
    }
    this.imageFile = null;
    this.imageLoadedUrl = null;
  }

  async saveImage(serviceType) {
    if (this.imageFile) {
        await this.uploadImage(this.imageFile, serviceType, this.formGroup.value.imageDescription);
      } else if (!this.imageFile && this.data.servicesTypeModel.imageFilename != null) {
        await this.deleteImage(serviceType);
      }
  }

  async getServiceDetails(fields: ServicesTypeModel) {
    try {
      
      const resultAdvantages = await this.servicesConfigService.getServiceAdvantages(fields.institutionId, fields.serviceContractId, fields.serviceId).toPromise();
      const resultDetails = await this.servicesConfigService.getServiceDetails(fields.institutionId, fields.serviceContractId, fields.serviceId).toPromise();
      
      if (Array.isArray(resultAdvantages?.advantages) && resultAdvantages.advantages.length > 0) {
        this.advantagesObject.advantages = resultAdvantages.advantages;
      }
      if (Array.isArray(resultDetails?.details) && resultDetails.details.length > 0) {
        this.detailsObject.details = resultDetails.details;
      }
    }catch (err) {
      console.error('Erro ao carregar detalhes do serviço',err);
    }
  }

  async getServiceImage(fields: ServicesTypeModel) {
    try {
      var blob = await this.servicesConfigService.getServiceImage(fields.institutionId, fields.serviceContractId, fields.serviceId).toPromise();
      if (blob?.size > 0) {
        this.imageFile = new File([blob], fields.imageFilename, { type: 'image/jpeg', lastModified: new Date().getTime(), });
        var objectUrl = URL.createObjectURL(blob);
        this.imageLoadedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      }
    } catch (err) {
      console.error('Erro ao carregar imagem do serviço',err);
    }
  }

  async uploadImage(file: File, serviceModel: ServicesTypePostModel, imageDescription: string) {
    try {
     await this.servicesConfigService.uploadServiceImage(serviceModel.institutionId, serviceModel.serviceContractId, file, serviceModel.serviceId.toString(), imageDescription)
      .toPromise();
    } catch (err) {
      this.dialogService.openDialog(Messages.UPLOAD_IMAGE_ERROR);
    }
  }

  async deleteImage(serviceModel: ServicesTypePostModel) {
    try {
      await this.servicesConfigService.deleteServiceImage(serviceModel.institutionId, serviceModel.serviceContractId, serviceModel.serviceId.toString()).toPromise();
    } catch (err) {
      this.dialogService.openDialog(Messages.EDIT_SAVE_ERROR);
    }
  }
}
